import { enqueueSnackbar, DownloadFile } from 'actions';

import {
	GetSitesRequest,
	GenerateReportRequest,
	SyncTrackerRequest,
	GetTrackerLastUpdateRequest
} from '../requests/ReportsRequests';

export const GET_SITES = 'GET_SITES';
export const SET_SELECTED_SITES = 'SET_SELECTED_SITES';
export const GET_TRACKER_LAST_UPDATE = 'GET_TRACKER_LAST_UPDATE';

const onGetSites = (value) => ({
	type: GET_SITES,
	sites: value
});

const onSetSelectedSites = (value) => ({
	type: SET_SELECTED_SITES,
	selectedSites: value
});

const onGetTrackerLastUpdate = (value) => ({
	type: GET_TRACKER_LAST_UPDATE,
	lastUpdate: value
});

export const GetSites = () => async (dispatch) => {
	await GetSitesRequest().then(response => {
		dispatch(onGetSites(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GenerateReport = (siteList, username, userId) => async (dispatch) => {
	await GenerateReportRequest(siteList, username, userId).then(response => {
		dispatch(enqueueSnackbar({ message: 'Your request is being processed. Your file will be available on Downloads soon.', options: { variant: 'info' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetSelectedSites = (selectedSites) => (dispatch) => {
	dispatch(onSetSelectedSites(selectedSites));
};

export const GetTrackerLastUpdate = () => async (dispatch) => {
	await GetTrackerLastUpdateRequest().then(response => {
		dispatch(onGetTrackerLastUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SyncTracker = () => async (dispatch) => {
	await SyncTrackerRequest().then(response => {
		dispatch(GetSites());
		dispatch(GetTrackerLastUpdate());
		dispatch(enqueueSnackbar({ message: 'Tracker synchronized successfully!', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
